import { show } from 'features/Toasts/Toasts.actions.js'
import { get } from 'lodash'

/** *******************************************************************

This middleware will add an error toast when possible.

******************************************************************** */

const middleware = store => next => action => {
  if (get(action, 'type', '').endsWith('_REJECTED')) {
    const data = get(action, 'payload.response.data', [])

    if (data.message) {
      // Errors to ignore
      if (['ERR_TOKEN_EXPIRED', 'ERR_TOKEN_NOT_FOUND'].includes(data.error)) {
        return next(action)
      }
      {
        store.dispatch(
          show({
            type: 'error',
            title: data.message,
          })
        )
      }
    } else if (data && data.length >= 0) {
      data.forEach(item => {
        store.dispatch(
          show({
            type: 'error',
            title: item.error || item.message,
          })
        )
      })
    } else if (data.error) {
      store.dispatch(
        show({
          type: 'error',
          title: data.error.message || data.error,
        })
      )
    }
  }
  return next(action)
}

export default middleware



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Toasts/Toasts.middleware.js